import React, {useState, useContext, useEffect} from 'react';
import SearchBox from "../../../common/searchBox";
import { toast } from "react-toastify";
// import _ from "lodash";

import moment from 'moment';
import jsfiledownload from 'js-file-download'

import { DomainContext } from '../../../../context/domainContext';
import FilterDateCombo from '../../../common/filter/filterDateCombo';
import socketIOClient from '../../../../services/app/socketioService';
import FontAwesome from 'react-fontawesome';
import { downloadTask } from '../../../../services/download/dashboard';
import ProjectToday from './projectToday';
import { getProjectReport } from '../../../../services/report/reportProject';
import ProjectHistory from './projectHistory';

const ProjectReport = () => {

  const {domain } = useContext(DomainContext)
  const [search, setSearch] = useState('')
  const [filter, setDateFilter] = useState({filter: 'today', date: moment().format('YYYY-MM-DD')})  //useState({filter: 'day', date: '2020-05-02'})
  const [report, setReport] = useState({})

  const loadList = async() => {
    try {
        const { data: result } = await getProjectReport(filter)
        if(result.status==='success') {

          setReport(result.data.report)

        } else {
            toast.error(result.message)
        }
    } catch (error) {
        
    }
  }

  useEffect(() => {
    loadList()

    // eslint-disable-next-line
  }, [filter, domain])

  useEffect(()=> {
    socketIOClient.on('report-dashboard-main', (message) => {   
      const { domainid, workDate } = message
      if(!domainid || !workDate) return

      if(domainid===domain._id.toString() && filter.filter==='today' ) {
        loadList()
      }     
    })
    return () => { socketIOClient.off('report-dashboard-main')  }
    // eslint-disable-next-line
  },[])

  const handleReportDownload = async () => {
    try {
        const input = { date: filter.date }

        if(filter.filter==='week') input.dateEnd = moment(filter.date).add(6, 'day').format('YYYY-MM-DD') 
        if(filter.filter==='month') input.dateEnd = moment(filter.date).endOf('month').format('YYYY-MM-DD') 
        
        const {data: result, headers } = await downloadTask(input)

        if( result.status==='error') {
            // toast.error(result.message)
        } else {
            if ( headers['x-suggested-filename']==='nodata') {
                toast.error("No Report")
            } else {
                jsfiledownload(result, headers['x-suggested-filename'] || `report.xlsx`)
            }
        }
        
    } catch(err) {
    }
}


  if(!domain) {
    return (<div className="alert alert-warning" role="alert">Please Select Domain</div>)
  }

  return ( 
    <React.Fragment>
    <div className="row justify-content-end">
      <div className="col-auto mr-auto mb-3">
        <h4>Project Report</h4>
      </div>
      <div className="col-auto mb-3 d-none">
        <SearchBox value={search} onChange={value => setSearch(value)} />
      </div>
      <div className="col-auto p-0 d-none">
          <button type="button" onClick={handleReportDownload} className="btn btn-secondary">Download <FontAwesome name="download" /></button>
      </div>
      <div className="col-auto ml-3 mb-3">
        <FilterDateCombo enableFilter={['today', 'day', 'week', 'month']}  notifyDateFilter={filter => setDateFilter(filter)} />
      </div>
    </div>
    {['today'].includes(filter.filter) && <ProjectToday report={report} filter={filter} />}
    {['day', 'week', 'month'].includes(filter.filter) && <ProjectHistory report={report} filter={filter} />}
    </React.Fragment>
  );
}
 
export default ProjectReport;